module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbfd74bd93aba47fa6e777d2ce6d9b3d6.bfd74bd9.png";